import { Box, Divider, Stack, Typography, getContrastRatio, Button, MenuList, InputAdornment, TextField, IconButton } from '@mui/material';

import { DeleteForever, Keyboard, PersonSearch } from '@mui/icons-material';
import React, { useState } from 'react'

import __t from '../../lib/traduzioni';
import { Menu } from '@mui/material';
import { MenuItem } from "@mui/material";
import { indirizzoMapper } from '../account/Rubrica'; 
import { useTheme } from '@emotion/react';
import useBSSLogger from '../../hooks/useBSSLogger';
import { useDebounce, useWindowScroll } from 'react-use';
import BSSMenu from '../form/BSSMenu';
const {logger} = useBSSLogger();

const datiUtiliContatto = (contatto) => {
    const {ragionesociale } = contatto;
    const {labelParts, contattareParts} = indirizzoMapper({ragionesociale}, contatto)
    const {indirizzoLabel, localitaLabel, dettaglioIndirizzoLabel, contattareLabel} = labelParts;
    const {chiContattareLabel} = contattareParts;

    return {
        indirizzoLabel, localitaLabel, dettaglioIndirizzoLabel, contattareLabel, chiContattareLabel
    }
}

const ContattiConsigliati = ({menuConsigliati, setMenuConsigliati, consigliati, ctx, methods}) => {

    const theme = useTheme();
    const [term, setTerm] = useState(null);
    const [filtro, setFiltro] = useState(null);
    
    const [, cancel] = useDebounce(
        () => {
            logger.debug("aggiorno filtro", term, ctx)
            setFiltro(term)
        },
        500,         
        [term]
    )

    const filtroVuoto = [undefined, null, ''].includes(filtro);

    const consigliatiFiltrati = (consigliati?.[ctx] ?? [])
        .filter(consigliato => {

            const {indirizzoLabel = "", chiContattareLabel = ""} = datiUtiliContatto(consigliato);
            

            logger.debug("applico filtro per", filtro, "su", indirizzoLabel, chiContattareLabel)

            let esito = filtroVuoto || (
                !filtroVuoto && (
                    indirizzoLabel.toLowerCase().includes(filtro.toLowerCase()) || 
                    chiContattareLabel.toLowerCase().includes(filtro.toLowerCase())
                )
            )
            return esito;
        })

    const MenuProps = {
        open: menuConsigliati.ctx === ctx,        
        onClose: e => {
            setMenuConsigliati({ctx: null, anchor: null})
        },
        anchorEl: menuConsigliati.anchor,                      
        sx: {
            pt: 0,
            maxHeight: 350,
            '& .MuiPaper-root': {
                width: ["60%", "50%", "40%", "20%"],
            },                                                                        
            '& .MuiMenuItem-root': {
                cursor: "pointer",
                
                '&:nth-of-type(even)': {
                    
                    backgroundColor: "grey.200",
                },
                '&:hover': {
                    backgroundColor: 'primary.main',
                    color: getContrastRatio("#fff", theme.palette.primary.main) >= getContrastRatio("#000", theme.palette.primary.main) ? "#fff" : "#000"
                }
                
            }
        }
    }

    return (
        <BSSMenu
            {...{MenuProps}}            
        >           

            
            <Box sx={{
                position: "sticky",
                backgroundColor: "white",                    
                top: 0,
                zIndex: 2,
                px: 4,
                py: 1,
                root: {
                    width: "100%"
                }
            }}>
                <TextField 
                    size='small'
                    fullWidth
                    placeholder={__t("contatticompatibili")}
                    label={__t("contatticompatibili")}  
                    value={term}
                    // onFocus={e => (typeof e.target.select === 'function') &&  e.target.select()}
                    onChange={e => {
                        const val = e.target.value;
                        logger.debug("aggiorno filtro solo termine", val)
                        setTerm(val);
                    }}
                    sx={{
                        paddingRight: "0px",
                        paddingLeft: "0px"
                    }}    
                    InputProps={{
                        onKeyDown: e => {
                            logger.finest("key down", e)
                            e.stopPropagation()
                        },
                        sx: {pr: 0},
                        endAdornment: (
                            <InputAdornment position="start">
                                <PersonSearch />
                                {filtroVuoto && ![null, undefined, ""].includes(term) && (
                                    <Keyboard color={"warning"} />
                                )}
                                {!filtroVuoto && (
                                    <IconButton size='small' onClick={e => {
                                        setTerm("");
                                        setFiltro("");
                                    }}>
                                        <DeleteForever color={"error"} />
                                    </IconButton>
                                )}
                            </InputAdornment>
                        )
                    }}                                                            
                    
                />
                
            </Box>    
            <Divider />  
            
            <MenuList sx={{pt: 0}}>                                                  
                {consigliatiFiltrati.map(consigliato => {

                        const {indirizzoLabel, chiContattareLabel} = datiUtiliContatto(consigliato);

                        const label = <Stack>
                            <Box>
                                {indirizzoLabel.toUpperCase()}
                                {/* <br />
                                {localitaLabel.toUpperCase()}                      */}
                            </Box>                                
                            {/* <Box>
                                <small>
                                    {dettaglioIndirizzoLabel.toUpperCase()}
                                </small>
                            </Box> */}
                        
                            <Box>
                                {chiContattareLabel.toUpperCase()}
                            </Box>

                        </Stack>;
                        
                        return (
                            <MenuItem 
                                key={consigliato.id} 
                                onClick={e => {
                                    logger.debug("applico il contatto", consigliato, methods.getValues(ctx), "come", ctx)
                                    const {comune, proponiper, 
                                            azienda, esercizio, dtype, insTime, insUser, status, utente, multiDescr,                                                                                    
                                        ...resto} = consigliato
                                    methods.setValue(ctx, {
                                        ...methods.getValues(ctx),                                                                                    
                                        ...resto,                                                                                    
                                    })
                                    setMenuConsigliati({ctx: null, anchor: null})
                                    setTerm("");
                                    setFiltro("");
                                }}
                            >
                                <Stack width={"100% !important"} px={2} pt={2} pb={1}>

                                        <Typography variant={"caption"}>
                                            {label}
                                        </Typography>

                                        <Button fullWidth variant={"contained"} color={"secondary"}>{__t("usacome", [__t(ctx)])}</Button>
                                </Stack>

                                <Divider />
                            </MenuItem>
                        )
                    })
                }
            </MenuList>
                
        </BSSMenu>
    )
}


export default ContattiConsigliati